import script from "./indeasaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./indeasaPage.vue?vue&type=script&setup=true&lang=js"

import "./indeasaPage.vue?vue&type=style&index=0&id=b02b7fae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b02b7fae"]])

export default __exports__